export const ACCESS_TOKEN = 'ACCESS_TOKEN';

export const setAccessToken = (accessToken: string) => {
  accessToken && localStorage.setItem(ACCESS_TOKEN, accessToken);
};

export const removeAccessToken = () => {
  localStorage.removeItem(ACCESS_TOKEN);
};

export const getAccessToken = (): string => {
  return localStorage.getItem(ACCESS_TOKEN) || '';
};

/**
 * True when there is no token, or the one we hold has expired. Reads `exp` out of the
 * JWT payload without verifying the signature - that is the server's job; here it only
 * decides whether a rejected request means "your session ended" or "you lack access".
 */
export const isAccessTokenExpired = (): boolean => {
  const token = getAccessToken();
  if (!token) return true;

  try {
    const payload = token.split('.')[1];
    if (!payload) return true;
    const normalised = payload.replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(normalised));
    if (typeof claims.exp !== 'number') return false;
    return claims.exp * 1000 <= Date.now();
  } catch {
    // Unparseable token is no better than a missing one
    return true;
  }
};
